// Utility: fetch video snippet (title + description) via YouTube Data API v3
export async function fetchYoutubeSnippet(videoId, apiKey, timeoutMs = 10000) {
    if (!videoId) throw new Error('No videoId provided');
    if (!apiKey) throw new Error('No YouTube API key configured');

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), timeoutMs);
    try {
        const url = `https://www.googleapis.com/youtube/v3/videos?part=snippet&id=${encodeURIComponent(videoId)}&key=${encodeURIComponent(apiKey)}`;
        const res = await fetch(url, { signal: controller.signal });
        clearTimeout(timeout);
        if (!res.ok) {
            let body = '';
            try { body = await res.text(); } catch (e) {}
            let msg = `HTTP ${res.status}`;
            try {
                const j = JSON.parse(body || '{}');
                if (j.error && j.error.message) msg = j.error.message;
            } catch (e) {}
            throw new Error(msg);
        }
        const data = await res.json();
        if (!data.items || data.items.length === 0) throw new Error('Video not found');
        const snippet = data.items[0].snippet || {};
        return { title: snippet.title || '', description: snippet.description || '' };
    } catch (err) {
        if (err.name === 'AbortError') throw new Error('Tiempo de espera agotado al consultar YouTube');
        throw err;
    } finally {
        clearTimeout(timeout);
    }
}

export default { fetchYoutubeSnippet };
